import { css } from 'styled-components';
import { getCurrentBrowserType } from '../../PdfViewer/helper';

const {
    isSafari,
    isMobile,
    isTablet,
} = getCurrentBrowserType();

let lineHeight = "24px";
if (isSafari) {
    if (!isMobile && !isTablet)
        lineHeight = "26px";
}
else {
    lineHeight = "24px";
}

export const UomSelectStyled = css`
    .ant-input-suffix {
        margin-left: -1px;
    }

    .uom-select {
        font-size: 75%;
        border: 0 !important;
        
        .ant-select-selection-item {
            line-height: ${lineHeight} !important;
        }

        .ant-select-selector {
            padding: 0 0 0 4px !important;
        }

        .base-uom-select-item {
            display: none;
        }
    }
`;
